var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30V37C0 49.7025 10.2974 60 23 60H31.9508H40.9016C53.6041 60 63.9016 49.7025 63.9016 37V30.0148C63.9016 30.0099 63.9016 30.0049 63.9016 30C63.9016 29.9951 63.9016 29.9901 63.9016 29.9852V23C63.9016 10.2975 53.6041 0 40.9016 0H31.9508H23C10.2974 0 0 10.2975 0 23V30Z",
    fill: "#8280FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0107 23.3333C22.0107 26.2789 24.5538 28.6667 27.6909 28.6667C30.8279 28.6667 33.371 26.2789 33.371 23.3333C33.371 20.3878 30.8279 18 27.6909 18C24.5538 18 22.0107 20.3878 22.0107 23.3333ZM36.2111 28.667C36.2111 30.8761 38.1184 32.667 40.4712 32.667C42.824 32.667 44.7313 30.8761 44.7313 28.667C44.7313 26.4579 42.824 24.667 40.4712 24.667C38.1184 24.667 36.2111 26.4579 36.2111 28.667Z",
    fill: "#8280FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6668 31.333C20.9622 31.333 15.4615 34.5684 14.9111 40.9319C14.8811 41.2786 15.5871 41.9997 15.9432 41.9997H39.4011C40.4678 41.9997 40.4844 41.1936 40.4678 40.933C40.0517 34.3906 34.4658 31.333 27.6668 31.333ZM48.2187 42.0002H42.7431C42.7431 38.9989 41.6869 36.2292 39.9045 34.001C44.742 34.0505 48.6919 36.3469 48.9892 41.2002C49.0011 41.3956 48.9892 42.0002 48.2187 42.0002Z",
    fill: "#8280FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStats);
export default __webpack_public_path__ + "static/media/userStats.d381b06c262eca41459a01d5a668a696.svg";
export { ForwardRef as ReactComponent };